import React, {useEffect, useRef, useState} from 'react';
import {observer} from "mobx-react-lite";
import { Screen, ScreenSlice } from 'react-screen';
import {useWebPSupportCheck} from "react-use-webp-support-check";
import FirstSection from "../components/SolutionsCasino/FirstSection";
import SecondSection from "../components/SolutionsCasino/SecondSection";
import Loader from "../components/Loader";
import Header from "../components/Header";
import Seo from "../components/Seo";

import "overlayscrollbars/css/OverlayScrollbars.css";
import 'react-screen/dist/react-screen.css';
import bgwebp from "../img/bg.webp";
import bgpng from "../img/bg.png";

const SolutionsCasinoPage = () => {
    const ref = useRef(null)
    const supportsWebP = useWebPSupportCheck();
    const [isLoading, setIsLoading] = useState(true);

    const ScrollScreen =() => {
        if (window.innerWidth > 1366 && ref) {
            const wrapper = ref.current.refs.wrapper;
            wrapper.querySelector('.react-screen').style.animationDuration = '.5s'
            if (wrapper.querySelector('.react-screen').classList.contains('in')) {
                document.querySelector('#to').classList.remove('height0')
            } else {
                document.querySelector('#to').classList.add('height0')
            }
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", ScrollScreen);
        return () => {
            window.removeEventListener("scroll", ScrollScreen);
        };
    });


    useEffect(() => {
        if (window.innerWidth > 1366 && ref && !isLoading) {
            const wrapper = ref.current.refs.wrapper;
            wrapper.querySelector('.react-screen').style.animationDuration = 'inherit'
            wrapper.querySelector('.react-screen').classList.add('in')
            wrapper.classList.remove('out')
            wrapper.querySelector('.react-screen-background').classList.remove('out')
            wrapper.querySelector('.react-screen').classList.remove('out')
            wrapper.querySelector('.react-screen').classList.add('anim')
        }
    }, [ref, isLoading])

    return (
        <div className="container_fluid">
            <Seo page='solutions_casino' />
            {isLoading ?? !ref ? <Loader /> : null}
            <div className="decision background" style={{backgroundImage: `url(${supportsWebP ? bgwebp : bgpng})`}}>
                <Header />
                {window.innerWidth > 1366
                    ? <Screen sliceHeight={60} delay={700} showSkip={false} ref={ref}>
                        <ScreenSlice>
                            <FirstSection isLoading={isLoading} setIsLoading={setIsLoading} />
                        </ScreenSlice></Screen>
                    : <FirstSection isLoading={isLoading} setIsLoading={setIsLoading} />}
                <SecondSection />
            </div>
        </div>
    );
};

export default observer(SolutionsCasinoPage);